module.exports = __webpack_public_path__ + "static/scene-2.16716c38.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/scene-2.png
// module id = 301
// module chunks = 2